export const localStorageKeys = {
    newsLetterSubscription: 'newsLetterSubscription'
}
